import { render, staticRenderFns } from "./updateEnclosure.vue?vue&type=template&id=125f0e9d&scoped=true"
import script from "./updateEnclosure.vue?vue&type=script&lang=js"
export * from "./updateEnclosure.vue?vue&type=script&lang=js"
import style0 from "./updateEnclosure.vue?vue&type=style&index=0&id=125f0e9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f0e9d",
  null
  
)

export default component.exports